export const PREFIX = 'WALLET/SEND';
